import React from "react";
import {
  Package, Sparkles, Camera, Megaphone, Clapperboard, Share2, Globe, Store, TrendingUp, Search,
  Calculator, Settings2, Wand2, Wrench, UserCircle2, Bookmark, Image as ImageIcon, Video, Mic, FileText,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { ACCENT_CLASSES } from "@/data/ai-lab/categories";

export const ICONS = {
  Package, Sparkles, Camera, Megaphone, Clapperboard, Share2, Globe, Store, TrendingUp, Search,
  Calculator, Settings2, Wand2, Wrench, UserCircle2, Bookmark, ImageIcon, Video, Mic, FileText,
};

/** Renders a Lucide icon by name inside an accent-colored square. */
export default function CategoryIcon({ icon = "Sparkles", accent = "slate", size = "md", className }) {
  const Icon = ICONS[icon] || Sparkles;
  const box = size === "lg" ? "h-12 w-12 rounded-2xl" : size === "sm" ? "h-8 w-8 rounded-lg" : "h-10 w-10 rounded-xl";
  const glyph = size === "lg" ? "h-6 w-6" : size === "sm" ? "h-4 w-4" : "h-5 w-5";
  return (
    <span className={cn("inline-flex shrink-0 items-center justify-center text-white shadow-sm", box, ACCENT_CLASSES[accent]?.icon || "bg-slate-600", className)}>
      <Icon className={glyph} aria-hidden="true" />
    </span>
  );
}

export const OUTPUT_TYPE_ICON = { text: FileText, image: ImageIcon, video: Video, audio: Mic };
